import React from 'react'
import "./Home.scss"
import zaapOmbre from "./../../Asset/Home/zaapOmbre.png"
import { NavLink } from 'react-router-dom';
// import { useState } from 'react';



export default function Home() {


  return (
    <div className="home">
        <h1>Bienvenue sur <span>DofuStuffSimulator</span></h1>
        <div className="newStuff__container">
          <NavLink to="/stuff" className="newStuffLink" >
            <div className="newStuff__wrapper">
              <img src={zaapOmbre} alt="" />
              <button className='newStuffBtn'>
                Créer un nouveau stuff
              </button>
            </div>
          </NavLink>
        </div>
    </div>
  )
  }
  